var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14782",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Video"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Video",
    d: "M7.114 19.749A3.912 3.912 0 013 15.688v-2.856a5 5 0 007-4.583 4.969 4.969 0 00-1.429-3.5H12.9a3.909 3.909 0 014.117 4.06v6.879a3.911 3.911 0 01-4.117 4.061zm13.843-2.38l-1.48-.747a1.624 1.624 0 01-.888-1.457V9.332a1.618 1.618 0 01.888-1.455l1.481-.749a1.384 1.384 0 011.373.064A1.432 1.432 0 0123 8.411v7.676a1.43 1.43 0 01-.669 1.219 1.4 1.4 0 01-.743.216 1.384 1.384 0 01-.631-.152zM1 8.249a4 4 0 114 4 4 4 0 01-4-4zm1.331 0a.456.456 0 00.456.453h1.758v1.752a.453.453 0 10.906 0V8.7h1.764a.451.451 0 000-.9H5.452V6.038a.453.453 0 00-.906 0v1.76H2.788a.454.454 0 00-.456.451z"
  }))));
}
export default SvgCreateVideoIcon;